import { Condition } from '../types'

const today = new Date().toISOString().split('T')[0]
const nextWeek = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
  .toISOString()
  .split('T')[0]
const lastWeek = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  .toISOString()
  .split('T')[0]

export const mockConditions: Condition[] = [
  {
    id: 'c1',
    name: 'Appraisal',
    description:
      'Provide a full interior/exterior appraisal report (1004) from an AMC.',
    status: 'Need',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Justin Elwood',
    priority: 'High',
    includeInNextEmail: true,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: false,
    source: 'Underwriter',
    notes: 'Ordered on 10/12, waiting for AMC assignment.',
  },
  {
    id: 'c2',
    name: 'Title Report',
    description: 'Preliminary title report with 24-month chain of title.',
    status: 'Requested',
    category: 'Prior to Docs',
    requestedDate: lastWeek,
    receivedDate: null,
    clearedDate: null,
    dueDate: today,
    assignedTo: 'Ordering Team',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: false,
    source: 'Processor',
    notes: 'Escrow opened, title requested.',
  },
  {
    id: 'c3',
    name: 'VOE - Verbal Verification',
    description:
      'Verbal verification of employment within 10 days of the note date.',
    status: 'Need',
    category: 'Prior to Funding',
    requestedDate: today,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Justin Elwood',
    priority: 'Medium',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: false,
    source: 'Underwriter',
    notes: '',
  },
  {
    id: 'c4',
    name: 'Pay Stubs',
    description: 'Most recent 30 days of pay stubs for all borrowers.',
    status: 'Received',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: today,
    clearedDate: null,
    dueDate: today,
    assignedTo: 'Justin Elwood',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: true,
    source: 'Loan Officer',
    notes: 'Uploaded by borrower this morning.',
  },
  {
    id: 'c5',
    name: 'Bank Statements',
    description: 'Two most recent months of bank statements (all pages).',
    status: 'Review',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: lastWeek,
    clearedDate: null,
    dueDate: today,
    assignedTo: 'Underwriting Team',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: true,
    source: 'Underwriter',
    notes: 'Large deposit on page 3 needs sourcing.',
  },
  {
    id: 'c6',
    name: 'HOI Declaration Page',
    description:
      'Homeowners insurance declaration page with sufficient coverage.',
    status: 'Need',
    category: 'Prior to Docs',
    requestedDate: today,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Processor',
    priority: 'Medium',
    includeInNextEmail: true,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: false,
    source: 'Processor',
    notes: 'Need mortgagee clause updated.',
  },
  {
    id: 'c7',
    name: 'Tax Returns',
    description:
      'Last 2 years of personal tax returns (1040s) with all schedules.',
    status: 'Cleared',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: lastWeek,
    clearedDate: today,
    dueDate: today,
    assignedTo: 'Underwriting Team',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: true,
    source: 'Underwriter',
    notes: 'Income calculated and matches 1003.',
  },
  {
    id: 'c8',
    name: 'Gift Letter',
    description: 'Signed gift letter and proof of transfer for $10,000 gift.',
    status: 'Need',
    category: 'Prior to Docs',
    requestedDate: today,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Justin Elwood',
    priority: 'High',
    includeInNextEmail: true,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: false,
    source: 'Underwriter',
    notes: 'Sent template to borrower.',
  },
  {
    id: 'c9',
    name: 'Flood Certification',
    description: 'Standard flood hazard determination form.',
    status: 'Cleared',
    category: 'Compliance',
    requestedDate: lastWeek,
    receivedDate: lastWeek,
    clearedDate: lastWeek,
    dueDate: lastWeek,
    assignedTo: 'Ordering Team',
    priority: 'Low',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: true,
    source: 'Compliance',
    notes: 'Not in flood zone.',
  },
  {
    id: 'c10',
    name: 'Survey',
    description: 'Property survey showing boundaries and improvements.',
    status: 'Waived',
    category: 'Prior to Closing',
    requestedDate: lastWeek,
    receivedDate: null,
    clearedDate: today,
    dueDate: nextWeek,
    assignedTo: 'Title Company',
    priority: 'Low',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: false,
    source: 'Underwriter',
    notes: 'Title company provided survey endorsement.',
  },
  {
    id: 'c11',
    name: 'Pest Inspection Invoice',
    description: 'Clear termite/pest inspection report and invoice.',
    status: 'Requested',
    category: 'Prior to Funding',
    requestedDate: today,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Justin Elwood',
    priority: 'Medium',
    includeInNextEmail: true,
    borrowerCanSeeInPortal: true,
    sentToUnderwriter: false,
    source: 'Processor',
    notes: 'Borrower scheduling inspection.',
  },
  {
    id: 'c12',
    name: 'Credit Supplement',
    description: 'Supplement to update balance on Chase credit card.',
    status: 'Review',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: today,
    clearedDate: null,
    dueDate: today,
    assignedTo: 'Underwriting Team',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: true,
    source: 'Underwriter',
    notes: 'Supplement received, balance is now $0.',
  },
  {
    id: 'c13',
    name: 'Condo Questionnaire',
    description: 'Completed full condo questionnaire from HOA.',
    status: 'Need',
    category: 'Approval',
    requestedDate: lastWeek,
    receivedDate: null,
    clearedDate: null,
    dueDate: nextWeek,
    assignedTo: 'Processor',
    priority: 'High',
    includeInNextEmail: false,
    borrowerCanSeeInPortal: false,
    sentToUnderwriter: false,
    source: 'Underwriter',
    notes: 'HOA is unresponsive, following up.',
  },
]
